import React from "react";
import { Button, Modal, Form, Input, Select } from "antd";
import store from "../../reducers";
const FormItem = Form.Item;
const Option = Select.Option;

const CUEmployeesModalForm = Form.create()(
	class ModalForm extends React.Component {
		render() {
			const { category1_title,
				category2_title,
				category3_title,
				category4_title
			} = store.getState().organization.organization;
			const { visible, confirmLoading, onCancel, onCreate, form, user, choice } = this.props;
			const { getFieldDecorator, resetFields } = this.props.form;
			const category_title = { category1_title, category2_title, category3_title, category4_title };
			return (
				<Modal
					visible={visible}
					title={user ? "Update user" : "Create new user"}
					okText={user ? "Update" : "Create"}
					onCancel={() => {
						resetFields();
						onCancel();
					}}
					onOk={onCreate}
					confirmLoading={confirmLoading}
					closable={false}
					maskClosable={false}
				>
					<Form layout="vertical">
						<FormItem label="E-mail">
							{getFieldDecorator("email", {
								rules: [{ required: true, message: "require E-mail!" }],
								initialValue: user ? user.email : ""
							})(<Input disabled={user ? true : false || confirmLoading} />)}
						</FormItem>
						{
							Object.keys(category_title).map((key, index) => {
								if (category_title[key]) {
									return (
										<FormItem key={index} label={category_title[key]}>
											{getFieldDecorator(`category${index + 1}`, {
												initialValue: user && user[`category${index + 1}`] ?
													user[`category${index + 1}`].data.id : null,
											})
											(
												<Select placeholder="Please select a choice">
													{
														choice[`choice${index + 1}`] && choice[`choice${index + 1}`].data && choice[`choice${index + 1}`]
															.data.map((value, index) => {
																return <Option key={index} value={value.id}>{value.name}</Option>;
															})
													}
												</Select>
											)
											}
										</FormItem>
									);
								}
							})
						}
					</Form>
				</Modal>
			);
		}
	}
);

class CUEmployees extends React.Component {
    state = {
    	visible: false,
    	confirmLoading: false,
    	data: null
    };
    showModal = (data = null) => {
    	this.setState({ visible: true, data });
    }
    handleCancel = () => {
    	const { confirmLoading } = this.state;
    	if (!confirmLoading)
    		this.setState({ visible: false, data: null });
    }
    handleCreate = () => {
    	const form = this.form;
    	form.validateFields((err, values) => {
    		if (err) {
    			return;
    		}
    		this.setState({ confirmLoading: true });
    		const { onSubmitAddEmployee, onSubmitEditEmployee } = this.props;
    		const { data } = this.state;
    		if (data && data.user) {
    			const payload = { id: data.user.id, payload: values };
    			onSubmitEditEmployee(payload).then(res => {
    				this.setState({
    					visible: false,
    					confirmLoading: false,
    				}, () => form.resetFields());
    			});
    		} else {
    			onSubmitAddEmployee(values).then(res => {
    				this.setState({
    					visible: false,
    					confirmLoading: false,
    				}, () => form.resetFields());
    			});
    		}
    	});
    }
    saveFormRef = (form) => {
    	this.form = form;
    }
    render() {
    	const { data } = this.state;
    	const { choice } = this.props;
    	return (
    		<CUEmployeesModalForm
    			ref={this.saveFormRef}
    			visible={this.state.visible}
    			confirmLoading={this.state.confirmLoading}
    			onCancel={this.handleCancel}
    			onCreate={this.handleCreate}
    			choice={choice}
    			user={data && data.user ? data.user : null}
    		/>
    	);
    }
}

export default CUEmployees;


// WEBPACK FOOTER //
// ./src/components/modal/CUEmployees.js